import React from 'react';

import { useTranslation } from '@external/react-i18next';

const CandidateList: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="border border-gray-300 py-4 px-3 mb-4">
      <h2 className="break-words">
        {t('mml.add-candidate-list.title', 'Candidate at a glance')}
      </h2>
      <h3 className="h5">
        {t('mml.add-candidate-list.member-type', 'Candidate type')}
      </h3>
      <p>Prospective member</p>
      <h3 className="h5">
        {t('mml.add-candidate-list.club-type', 'Club type')}
      </h3>
      <p>Rotaract</p>
      <h3 className="h5">{t('mml.add-candidate-list.status', 'Status')}</h3>
      <p>Candidate contacted</p>
      <h3 className="h5">{t('mml.add-candidate-list.notes', 'Notes')}</h3>
      <p>
        Ut sed neque bibendum, luctus dolor gravida, consequat arcu. Aenean in
        suscipit ligula. Fusce in ligula feugiat, pharetra elit sit amet, tempus
        dui.
      </p>
    </div>
  );
};

export default CandidateList;
